import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CurrentTradingTimeShiftFragment } from '../../../../graphql/service/graphql-auto-main-service';
import { TranslateService } from '@ngx-translate/core';
import { Duration, ToHumanDurationOptions } from 'luxon';

@Component({
  selector: 'app-lot-trading-time-shift',
  templateUrl: './lot-trading-time-shift.component.html',
  styleUrls: ['./lot-trading-time-shift.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotTradingTimeShiftComponent {
  @Input() tradingTimeShift?: CurrentTradingTimeShiftFragment | null;

  private readonly baseTranslationKey = 'LOT_INFO.TRADING_TIME_SHIFT';

  constructor(private translate: TranslateService) {}

  get isAhead(): boolean {
    return !!this.tradingTimeShift?.speedUp;
  }

  get directionKey(): string {
    return `${this.baseTranslationKey}.${this.isAhead ? 'AHEAD_OF' : 'BEHIND'}`;
  }

  get formattedShiftTime(): string {
    const shiftInSeconds = this.tradingTimeShift?.shiftInSeconds ?? 0;

    const duration = Duration.fromObject(
      { seconds: shiftInSeconds },
      { locale: this.translate.currentLang },
    ).shiftTo('hours', 'minutes');

    return duration.toHuman({
      unitDisplay: 'short',
      listStyle: 'narrow',
    } as ToHumanDurationOptions);
  }
}
